// extracted by mini-css-extract-plugin
export default {"melodyVideo":"UQ-z","isFullWidth":"VQ-z","landingPageVideo":"WQ-z","play":"XQ-z","iframeVideo":"YQ-z","playHidden":"ZQ-z","fullwidth":"_Q-z"};